import either, { right, left } from "@/lib/either";
import AuthRemoteDataSource from "../datasource/auth_remote_datasource";

const PutStatusRelativesUsecase = (data) =>
  either(async () => {
    try {
      const response = await AuthRemoteDataSource.relativesStatus(data);

      return right({
        type: "success",
        content: "Se ha actualizado correctamente",
        responseStatus: response.data.signUpStatus,
      });
    } catch (err) {
      return left({
        type: "error",
        content: "Ha ocurrido un error interno. Intentelo de nuevo",
        err,
      });
    }
  });

export default PutStatusRelativesUsecase;
